import { UPDATE_RESET_PASSWORD_IS_FETCHING } from 'constants/actions';

export const updateResetPasswordIsFetching = isFetching => {
  return { type: UPDATE_RESET_PASSWORD_IS_FETCHING, is_fetching: isFetching };
};
